import { ChangeDetectionStrategy, Component, signal } from '@angular/core';
import { FormsModule, NG_VALUE_ACCESSOR } from '@angular/forms';
import { MultiSelect } from 'primeng/multiselect';
import { ReportParameterBase } from './report-parameter-base';
import { SelectParameterOptions } from './select-parameter.component';

@Component({
    selector: 'app-multi-select-parameter',
    imports: [FormsModule, MultiSelect],
    template: `
        <p-multiselect 
            [id]="parameterKey()"    
            [ngModel]="selectedItems()"
            
            [options]="parameterOptions().options"
            optionLabel="label"
            optionValue="value"
            [placeholder]="parameterDefinition().placeholder"
            [showClear]="true"

            [disabled]="isDisabled()"
            [invalid]="isInvalid()"

            fluid

            (ngModelChange)="onModelChange($event)"
        />
    `,
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: MultiSelectParameterComponent,
            multi: true
        }
    ]
})
export class MultiSelectParameterComponent extends ReportParameterBase<unknown, SelectParameterOptions> {
    selectedItems = signal<unknown[]>([]);

    onModelChange(value: unknown[] | null) {
        const selected = value ?? [];
        this.selectedItems.set(selected);

        this.reportWorkspace.setParam(this.parameterKey(), selected);

        this.onChange(selected);
        this.markTouchedIfNotResetting();
    }

    // CVA callbacks
    writeValue(obj: unknown[] | null): void {
        this.selectedItems.set(obj ?? []);
    }
}
